import SweetAlert from "react-bootstrap-sweetalert";

const AlertV2Component = ({ show, title, type, message, hideAlert }) => {
  return (
    show && (
      <SweetAlert
        type={type}
        title={<span style={{ color: "#000" }}>{title}</span>}
        onConfirm={hideAlert}
        onCancel={hideAlert}
        showConfirm
      >
        <p className="text-muted">{message}</p>
      </SweetAlert>
    )
  );
};

export default AlertV2Component;
